<div class="row">
  <div class="col-md-12">
    <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
      <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
        <mat-card-title class="mat-mdc-card-title text-white">
          {{ 'Cost-Calculation'|translate }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="mat-mdc-card-content text-center">
        <span class="tilte">{{ 'RequiredProductsData'|translate }}</span>
        <div class="row">
          <div class="col-lg-6 m-t-20 m-b-15" *ngFor="let cost of TotalCostInputData;let i =index">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
              <mat-card-content class="mat-mdc-card-content text-center">
                <div class="row">
                  <div class="col-md-2 justify-content-center">
                    <img class="m-auto ms-5 product-img"
                         src="{{cost.subCategoryImage | adjust_image_path }}">
                  </div>
                  <div class="col-md-9">
                    <span class="TypeName"> {{ cost.typeName }}</span>

                    <table class="w-100 m-b-20">
                      <tr>
                        <td>
                                                    <span class="span-title">{{ 'Color' | translate }} :
                                                    </span>
                          <span>{{ cost.colorName }} </span>
                        </td>
                        <td>
                                                    <span class="span-title">{{ 'Length' | translate }} :
                                                    </span>
                          <span>{{ cost.height }} {{ 'Meter' | translate }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                                                    <span class="span-title"> {{ 'width' | translate }} :
                                                    </span>
                          <span>{{ cost.width }} {{ 'Meter' | translate }}</span>
                        </td>
                        <td>
                                                    <span class="span-title">{{ 'NumberOfMeters' | translate }} :
                                                    </span>
                          <span>{{ calcSquareMeter(cost) }}
                            {{ 'squareMeter'|translate }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="span-title">{{ 'RequiredCount' | translate }} : </span>
                          <span>{{ cost.count ?? 1 }}</span>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="tblTitle">
                  <span>{{ 'CostPerMeter' | translate }} : </span>
                  <span>
                                        {{ GetMeterCost(TotalCostData.meterCosts, cost, i) }}
                    {{ 'EGP'|translate }}
                                    </span>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <mat-divider></mat-divider>

        <div class="div-tbl m-b-30">
          <table class="table w-100" *ngIf="TotalCostData?.items">
            <thead>
            <tr>
              <th class="th-data">{{ 'Name'|translate }}</th>
              <th class="th-data">{{ 'NumberOfMeters'|translate }}</th>
              <th class="th-data">{{ 'cost'|translate }}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of TotalCostData?.items">
              <td>{{ item?.productName }}</td>
              <td>{{ item?.totalQuantityForAllProducts }} {{ item?.unit }}</td>
              <td>{{ item?.totalCostForAllProducts }} {{ 'EGP'|translate }}</td>
            </tr>
            </tbody>
            <tbody *ngFor="let cost of costCalcAdds|keyvalue">

            <tr *ngIf="cost">
              <td colspan="2">
                {{ cost?.key }}
              </td>
              <td>
                {{ ClacAllAdditions(cost?.value) }}
                {{ 'EGP'|translate }}
              </td>
            </tr>
            </tbody>
          </table>

          <div class="tblTitle m-t-10">
            <span>{{ 'TotalPrice' | translate }} : </span>
            <span>
                            {{ TotalCostData.totalCost ?? 0 }}
              {{ 'EGP'|translate }}
                        </span>
          </div>
        </div>
        <div class="calc-cost-actionbar">
            <a (click)="Close()" class="btn btnClose">
              {{ 'Back' | translate }}
            </a>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
